import { createFileRoute } from '@tanstack/react-router'

import { CompanyUsersPage } from '@/pages/company-members/CompanyUsers.page'

export const Route = createFileRoute('/_auth/$companyId/spaces/users')({
  component: CompanyUsersPage,
  loader: () => ({ breadcrumbTitle: 'Users' }),
})
